import { createContext, useState, ReactNode, FC } from 'react';

interface AuthState {
    username: string | null;
    isAuthenticated: boolean;
    office: string | undefined;
    authority:string;
}

export interface AuthContextType {
    auth: AuthState;
    setAuth: React.Dispatch<React.SetStateAction<AuthState>>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
    children: ReactNode;
}

const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
   
const [auth, setAuth] = useState<AuthState>({
  username: null,
  isAuthenticated: false,
  office: undefined,
  authority:"user"
});

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export { AuthContext, AuthProvider };